module.exports = __webpack_public_path__ + "static/img/color.a0e149ea.jpg";